import { createSlice } from '@reduxjs/toolkit';

import * as appConfig from '@sophocles/config';
import { loadTenant } from '@sophocles/features/tenant/api';
import TENANT_DEFAULTS from '@sophocles/features/tenant/defaults';

// Optional local brand COLOR overrides from config.js, applied to the
// FIRST-PAINT SEED ONLY. They let the nav paint the tenant's color on the
// very first render, before the /api/tenant/ fetch resolves — avoiding a
// flash of the default blue. Once the backend TenantConfig row loads, the
// model is authoritative for colors too (see loadTenant.fulfilled below), so
// an admin editing colors in the model takes effect without a config rebuild.
// Logos likewise come from the model (see TenantThemeProvider), never config.
// Optional reads — absent from most config.js files (incl. the S3-sourced CI
// configs), so the import/namespace rule can't validate the members.

const BRAND_PRIMARY_OVERRIDE = appConfig.BRAND_PRIMARY || null;
const BRAND_SECONDARY_OVERRIDE = appConfig.BRAND_SECONDARY || null;

const seedBrandColors = info => {
  if (!BRAND_PRIMARY_OVERRIDE && !BRAND_SECONDARY_OVERRIDE) {
    return info;
  }
  return {
    ...info,
    ...(BRAND_PRIMARY_OVERRIDE ? { primary_color: BRAND_PRIMARY_OVERRIDE, navbar_color: BRAND_PRIMARY_OVERRIDE } : {}),
    ...(BRAND_SECONDARY_OVERRIDE ? { secondary_color: BRAND_SECONDARY_OVERRIDE } : {}),
  };
};

const slice = createSlice({
  name: 'tenant',
  // ``info`` is read via ``state.tenant.info`` (see selector below) and
  // written by ``loadTenant.fulfilled`` as ``state.info = ...``. Seeded from
  // TENANT_DEFAULTS (+ config.js colors) so nav consumers paint the correct
  // brand color on first render before the /tenant/ fetch resolves.
  initialState: {
    info: seedBrandColors({ ...TENANT_DEFAULTS }),
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(loadTenant.fulfilled, (state, action) => {
        // Backend TenantConfig is the source of truth — no config.js override.
        state.info = action.payload;
      })
      .addCase(loadTenant.rejected, (state, action) => {
        console.log('failed to load tenant!', action);
      });
  },
});

export const selectTenantInfo = state => {
  return state.tenant.info;
};

export const selectDisableThirdPartyApi = state => Boolean(state.tenant.info?.disable_third_party_api);

export const selectSeparateTenant = state => Boolean(state.tenant.info?.separate_tenant);

const { reducer } = slice;
export default reducer;
